import React, { useState, useRef, useEffect } from 'react';
import {DropdownItem} from './DropdownItem'
import {useTCData} from "../../context"


export const SearchBar = ({ team, setTeam }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const {activeTCData} = useTCData()
  const [filteredData, setFilteredData] = useState(activeTCData);

  const onSearch = (value) => {
      const filtered = activeTCData.filter((item) => {
          const {name} = item
          return name.toLowerCase().includes(value.toLowerCase())}
      );
      setFilteredData(filtered);
  };

  useEffect(() => {

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    }
}, [dropdownRef])

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    onSearch(value);
    setIsOpen(true);
  };

  const handleSelect = (option) => {
    setSearchTerm("");
    onSearch(option);
    setIsOpen(false);
  };

  return (
    <div className="field">
      <div className="control has-icons-left">
        <input
          className="input"
          type="text"
          placeholder="Search"
          value={searchTerm}
          onChange={handleSearch}
        />
        <span className="icon is-left">
          <i className="fas fa-search" aria-hidden="true"></i>
        </span>
      </div>
      {isOpen && (
        <div className="dropdown is-active" ref={dropdownRef}>
            <div className="dropdown-menu">
                <div className="dropdown-content" style={{maxHeight: "200px", overflow: "auto"}}>
                    {filteredData.map((item, i) => <DropdownItem item={item} key={"Dropdown" + i} team={team} setTeam={setTeam} handleSelect={handleSelect} />)}    
                </div> 
            </div>
        </div>
      )}
    </div>
  );
};

export default SearchBar;
